module.exports = __webpack_public_path__ + "img/USA-Best-2040 - 2069.c2975cb6.png";